const LOGIN = {
  LOGIN: 'ログイン',
  FORGOT_PASSWORD: 'パスワードをお忘れの方は',
  HEAR: 'こちら',
  PASSWORD_RESET_FORM: 'パスワード再設定フォーム',
  LOGIN_ID: 'メールアドレス',
  PASSWORD: 'パスワード',
  ERROR_NAME: 'メールアドレスは必須です',
  ERROR_PASSWORD: 'パスワードは必須です',
  ERROR_Login: 'メールアドレスまたはパスワードが無効です',
  ERROR_NOT_CONFIRM_REGULATIONS: '代表者様が利用規約に同意するまでログインできません',
};

const CONST_LOGIN_PAGE = { LOGIN };

export default CONST_LOGIN_PAGE;
